const createTotalsService = ({ getDeliveries }) => {
  const getTotalInfoByArticleList = articleList => {
    const deliveries = getDeliveries()
    // Set для O(1) поиска вместо Array.includes() → O(n) на каждой итерации
    const articleSet = new Set(articleList)

    let productInfo = {
      price: 0,
      amount: 0,
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
    }

    Object.keys(deliveries).forEach(formattedDate => {
      const productModels = deliveries[formattedDate]
      productModels.forEach(productModel => {
        if (articleSet.has(productModel.article)) {

          const normAmount = productModel.amount < 0 ? 0 : productModel.amount
          if (productModel.priceType === 'best' && productModel.bestPrice > 0) {
            productInfo.price += normAmount * productModel.bestPrice
          } else {
            productInfo.price += normAmount * productModel.price
          }

          productInfo.amount += normAmount
        }

        productInfo.weight += productModel.weight
        productInfo.length += productModel.length
        productInfo.width += productModel.width
        productInfo.height += productModel.height
      })
    })

    return productInfo
  }

  return { getTotalInfoByArticleList }
}

export { createTotalsService }
export default createTotalsService
